import "style/style.scss";
import HomePage from "pages/HomePage";
import Registration from "pages/Registration";
import Pricelist from "pages/Pricelist";
import { DropdownMenu } from "components/DropdownMenu";
import { Navigation } from "components/Navigation";
import TalentsPage from "pages/TalentsPage";
import Team from "pages/Team";
import { DropzoneUpload } from "components/DropzoneUpload";
import TalentForm from "pages/TalentForm";
import Recommendations from "pages/Recommendations";
import PitchTender from "pages/PitchTender";
import { ContactForm } from "components/ContactForm";

const configDropdownMenu = {
  dropdownList: $(".js-dropdown-list"),
  dropdownTrigger: $(".js-dropdown-trigger")
};

const configNavigation = {
  menuTrigger: $(".menuTrigger"),
  navigation: $(".js-navigation"),
  navigationListItem: $(".navigation__list li"),
  navigationFooterItem: $(".navigation__footer li")
};

const configContactForm = {
  formTrigger: $(".js-form-trigger"),
  formClose: $(".js-form-close")
};

const configDropzone = {
  dropzoneWrapper: $(".js-dropzone")
};

$(document).ready(() => {
  const dropdownMenu = new DropdownMenu(configDropdownMenu);
  dropdownMenu.init();

  const homePage = new HomePage();
  homePage.init();

  const registration = new Registration();
  registration.init();

  const pricelist = new Pricelist();
  pricelist.init();

  const navigation = new Navigation(configNavigation);
  navigation.init();

  const categoryCards = new TalentsPage();
  categoryCards.init();

  const team = new Team();
  team.init();

  const dropzoneUpload = new DropzoneUpload(configDropzone);
  dropzoneUpload.init();

  const talentForm = new TalentForm();
  talentForm.init();

  const pitchTender = new PitchTender();
  pitchTender.init();

  const recommendations = new Recommendations();
  recommendations.init();

  const contactForm = new ContactForm(configContactForm);
  contactForm.init();

  $(".js-range-slider").each(function() {
    var _this = $(this);
    _this.rangeslider({
      polyfill: false,
      onSlide: function(position, value) {
        _this
          .parent()
          .find(".js-range-output")
          .html(this.value);
      }
    });
  });

  if (platform.name === "Chrome Mobile") {
    $("body").addClass("chrome-mobile");
  } else if (
    platform.os.family === "iOS" &&
    window.innerWidth <= 800 &&
    platform.name === "Safari"
  ) {
    $("body").addClass("safari-mobile");
  }
});



// WEBPACK FOOTER //
// ./static/js/index.js